import styled from 'styled-components';

import { IconLocked } from 'components/icons/locked';
import { LoyaltyLoader } from 'pages/loyalty/loyalty-loader';
import { primitive } from 'styles/constants/primitives';
import { PointsDisplayIcon } from 'ui-system/components/points-display';

import {
  CarouselRewardName as DefaultCarouselRewardName,
  CategoryImage as DefaultCategoryImage,
  PointsNeededText as DefaultPointsNeededText,
  StyledPointsDisplayBadgeLocked as DefaultStyledPointsDisplayBadgeLocked,
  StyledPointsDisplayHeading as DefaultStyledPointsDisplayHeading,
} from './loyalty-rewards.styled.default';

export * from './loyalty-rewards.styled.default';

export const CategoryImage = styled(DefaultCategoryImage)`
  display: none;
`;
export const CarouselRewardName = styled(DefaultCarouselRewardName)`
  color: ${p => p.theme.token('text-link-default')};
  font-weight: 700;
`;

export const PointsNeededText = styled(DefaultPointsNeededText)`
  font-size: 1.3rem;
  margin: 0;

  ${Styles.desktop} {
    margin-inline-end: 0;
  }
`;

export const CarouselRewardLock = styled(IconLocked)`
  width: 1rem;
  height: 1rem;

  & path {
    fill: ${primitive.plk.$nolaDark};
  }
`;

export const LockOverlay = styled.div<{ condensed?: boolean }>`
  width: 100%;
  height: ${p => (p.condensed ? '6.25rem' : '8rem')};
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  background: ${primitive.$black};
  border-radius: 0.5rem;
  opacity: 0.5;

  ${Styles.desktop} {
    height: ${(p: any) => (p.condensed ? '7.375rem' : '13.5rem')};
  }
`;

export const StyledPointsDisplayHeading = styled(DefaultStyledPointsDisplayHeading)`
  font-family: ${Styles.fontFamily.base};
`;

export const StyledLoyaltyLoader = styled(LoyaltyLoader)``;

export const StyledPointsDisplayBadgeLocked = styled(DefaultStyledPointsDisplayBadgeLocked)`
  background: ${primitive.plk.$nolaLight};
  color: ${primitive.plk.$nolaDark};

  ${PointsDisplayIcon} path {
    fill: currentColor;
  }
`;
